/**
 * @generated SignedSource<<8d92d0f7ba68eee947dc992593bbde4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EAddressType = "EXTERNAL" | "PRIVY" | "SMART_WALLET" | "%future added value";
export type EZoraClaimContractEnv = "PRODUCTION" | "STAGING" | "%future added value";
export type EZoraTokenClaimStatus = "CLAIMED" | "NOT_CLAIMED" | "%future added value";
import { GraphQLStrAddress } from "@ourzora/universal-api/customTypes/GraphQLStrAddress";
export type useAccountAllocationsDataQuery$variables = {
  chainId: number;
  identifiers: ReadonlyArray<string>;
  zoraClaimContractEnv: EZoraClaimContractEnv;
};
export type useAccountAllocationsDataQuery$data = {
  readonly zoraTokenAllocation: {
    readonly totalTokensEarned: {
      readonly totalTokens: number;
      readonly walletAllocation: ReadonlyArray<{
        readonly claimStatus: EZoraTokenClaimStatus;
        readonly tokens: number;
        readonly walletAddress: GraphQLStrAddress;
        readonly walletProfile: {
          readonly externalWallet?: {
            readonly walletAddress: GraphQLStrAddress;
          } | null | undefined;
          readonly handle: string;
          readonly id: string;
          readonly smartWallet?: {
            readonly smartWalletConfig: {
              readonly owners: ReadonlyArray<{
                readonly ownerAddress: any;
                readonly ownerIndex: number;
              }> | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"AvatarFragment">;
        } | null | undefined;
        readonly walletType: EAddressType | null | undefined;
      }>;
    };
  };
};
export type useAccountAllocationsDataQuery = {
  response: useAccountAllocationsDataQuery$data;
  variables: useAccountAllocationsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chainId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identifiers"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zoraClaimContractEnv"
},
v3 = [
  {
    "kind": "Variable",
    "name": "chainId",
    "variableName": "chainId"
  },
  {
    "kind": "Variable",
    "name": "identifierWalletAddresses",
    "variableName": "identifiers"
  },
  {
    "kind": "Variable",
    "name": "zoraClaimContractEnv",
    "variableName": "zoraClaimContractEnv"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTokens",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "claimStatus",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokens",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "walletAddress",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "walletType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "handle",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLSmartWalletOwner",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ownerAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ownerIndex",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAccountAllocationsDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "GraphQLZoraTokenAllocation",
        "kind": "LinkedField",
        "name": "zoraTokenAllocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLZoraTokenCategoryAllocation",
            "kind": "LinkedField",
            "name": "totalTokensEarned",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLZoraTokenCategoryWalletAllocation",
                "kind": "LinkedField",
                "name": "walletAllocation",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "walletProfile",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GraphQLLinkedWalletProfile",
                            "kind": "LinkedField",
                            "name": "smartWallet",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GraphQLSmartWalletProfile",
                                "kind": "LinkedField",
                                "name": "smartWalletConfig",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GraphQLLinkedWalletProfile",
                            "kind": "LinkedField",
                            "name": "externalWallet",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "GraphQLAccountProfile",
                        "abstractKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AvatarFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAccountAllocationsDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "GraphQLZoraTokenAllocation",
        "kind": "LinkedField",
        "name": "zoraTokenAllocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLZoraTokenCategoryAllocation",
            "kind": "LinkedField",
            "name": "totalTokensEarned",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLZoraTokenCategoryWalletAllocation",
                "kind": "LinkedField",
                "name": "walletAllocation",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "walletProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GraphQLLinkedWalletProfile",
                            "kind": "LinkedField",
                            "name": "smartWallet",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GraphQLSmartWalletProfile",
                                "kind": "LinkedField",
                                "name": "smartWalletConfig",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GraphQLLinkedWalletProfile",
                            "kind": "LinkedField",
                            "name": "externalWallet",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "GraphQLAccountProfile",
                        "abstractKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isIGraphQLProfile"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GraphQLMediaImage",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "small",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "blurhash",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6d3cac6623dc0f94a0fb1097572aa48d",
    "id": null,
    "metadata": {},
    "name": "useAccountAllocationsDataQuery",
    "operationKind": "query",
    "text": "query useAccountAllocationsDataQuery(\n  $identifiers: [String!]!\n  $chainId: Int!\n  $zoraClaimContractEnv: EZoraClaimContractEnv!\n) {\n  zoraTokenAllocation(identifierWalletAddresses: $identifiers, chainId: $chainId, zoraClaimContractEnv: $zoraClaimContractEnv) {\n    totalTokensEarned {\n      totalTokens\n      walletAllocation {\n        claimStatus\n        tokens\n        walletAddress\n        walletType\n        walletProfile {\n          __typename\n          id\n          handle\n          ... on GraphQLAccountProfile {\n            smartWallet {\n              smartWalletConfig {\n                owners {\n                  ownerAddress\n                  ownerIndex\n                }\n                id\n              }\n              id\n            }\n            externalWallet {\n              walletAddress\n              id\n            }\n          }\n          ...AvatarFragment\n        }\n      }\n    }\n  }\n}\n\nfragment AvatarFragment on IGraphQLProfile {\n  __isIGraphQLProfile: __typename\n  handle\n  avatar {\n    icon\n    small\n    blurhash\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b398bbac0e79afff55d8d82cb29a897";

export default node;
